import React, { PureComponent, PropTypes } from 'react';
import { hashHistory } from 'react-router';
import cn from 'classnames';
import styles from './styles.scss';


export class BackArrow extends PureComponent {
  constructor(props) {
    super(props);
    this.handleOnClick = this.handleOnClick.bind(this);
  }

  handleOnClick() {
    return hashHistory.push(this.props.destination);
  }


  render() {
    return (
      <div
        className="backArrowContainer"
      >
        <button
          className={cn(styles.backArrow, styles[this.props.styles])}
          onClick={this.handleOnClick}
        >
          <svg fill="#3fafd7" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" version="1.1">
            <path d="M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z" />
            <path d="M0 0h24v24H0z" fill="none" />
          </svg>
        </button>
      </div>
    );
  }
}

BackArrow.propTypes = {
  styles: PropTypes.string.isRequired,
  destination: PropTypes.string.isRequired,
};


export default BackArrow;



// WEBPACK FOOTER //
// ./src/components/sign_up/shared/backArrow/index.jsx